<mat-card style="height:550px;width:100%;overflow-x: hidden;">
 <form #loginForm="ngForm">
    <mat-toolbar style="width:100%;padding: 0 8px">
      <h2 mat-line style="width:80%;color: black">{{('notes.dialeg.titol') | translate}}</h2>
      <div style="float:left;clear:both;padding:16px;padding-left: 5px;width:95%">
          {{this.editNotesData.id}}
      </div>
      <div style="width:100%;float:right">
        <button mat-icon-button style="float:right;margin-right:0" (click)="close()" matTooltip="{{('notes.dialeg.tancar') | translate}}" attr.aria-label="{{('notes.dialeg.tancar') | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float:right;margin-right:0" (click)="desar()" matTooltip="{{('notes.dialeg.desar') | translate}}" attr.aria-label="{{('notes.dialeg.desar') | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress"></mat-progress-bar>

    <mat-card-content style="width:100%;float:left;clear:left;padding:5px">
      <div style="float:left;clear:both;width:100%;padding:5px">
       <mat-form-field style="float: left;clear: left;width:10%">
        <input matInput placeholder="{{ 'propostaMi.dates.data' | translate }}" name="dia" type="date" [(ngModel)]="dia" ngDefaultControl/>
       </mat-form-field>
       <button color="primary" mat-icon-button matTooltip="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="afegir(null)" style="float: left;clear: none;width:2%">
         <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
       </button>
      <mat-form-field style="width:40%;float:left;clear:none;margin-left: 20px;height:40px">
        <mat-select style="width:100%" placeholder="{{ 'propostaMi.seguiment.seguimentTreballs' | translate }}" (selectionChange)="afegir($event)">
          <mat-option *ngFor="let tipus of seguimentsTreballs" [value]="tipus.value">{{tipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <button color="primary" mat-icon-button matTooltip="{{ 'notesDialeg.editarSeguimentProjecteToolTip' | translate }}" attr.aria-label="{{ 'notesDialeg.editarSeguimentProjecteToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="this.editSeguimentTecnic()" style="float: left;clear: none;width:2%">
         <mat-icon style="font-size:24px;font-weight:bold">mode_edit</mat-icon>
      </button>
      <button color="primary" mat-icon-button matTooltip="{{ 'notesDialeg.afegirSeguimentProjecteToolTip' | translate }}" attr.aria-label="{{ 'notesDialeg.afegirSeguimentProjecteToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="this.addSeguimentTecnic()" style="float: left;clear: none;width:2%">
         <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
      </button>
      </div>

      <div style="float:left;clear:both;margin-top:0px;width:95%;padding-left: 5px">
         <quill-editor #quillEditor [styles]="{height: '200px', backgroundColor: '#EEEEEE'}" [(ngModel)]="editNotesData.observacions" name="observacions" placeholder="{{('notes.dialeg.cmpobservacions') | translate}}" (onSelectionChanged)="setPos($event)"></quill-editor>
         <button color="primary" mat-icon-button matTooltip="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" attr.aria-label="{{ 'propostaMi.seguiment.afegirDataToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="afegirE()" style="float: left;clear: none;width:2%">
         <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
         </button>
         <textarea style="width:100%;height:'100px';backgroundColor:'#dee8f4'" [(ngModel)]="editNotesData.nota_e" name="nota_e" placeholder="{{ 'propostaMi.seguiment.supervisio' | translate }}" (onSelectionChanged)="setPos($event)"></textarea>
      </div>

    <div style="float:left;clear:both;margin-top:0px;width:90%;padding-left:20px;background-color:#3f51b5" *ngIf="error !== ''">
      <span style="color:red;font-weight: bold">{{error}}</span>
    </div>

    </mat-card-content>
  </form>
</mat-card>
